import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from 'recharts'
import { Stack, Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { Theme } from '@mui/material/styles'

const legendContainer = {
  justifyContent: 'space-between',
  marginTop: '8px',
  flexDirection: 'row',
  paddingX: '8px',
}

const legendItem = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
}

const legendDot = (color: string) => ({
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  backgroundColor: color,
})

const legendLabel = {
  color: (theme: Theme) => theme.palette.text.primary,
  fontSize: 13,
}

type StackedBarChartType = {
  data: { name: string; value: number; color: string }[]
}

export const StackedSingleBarChart = ({ data }: StackedBarChartType) => {
  const theme = useTheme()

  return (
    <Stack>
      <ResponsiveContainer width="100%" height={56}>
        <BarChart
          data={[
            {
              name: 'Blend',
              ...data.reduce(
                (acc, item) => ({ ...acc, [item.name]: item.value }),
                {}
              ),
            },
          ]}
          stackOffset="expand"
          layout="vertical"
        >
          <XAxis type="number" hide />
          <YAxis type="category" dataKey="name" hide />
          <Tooltip formatter={(value) => `${value}%`} />
          {data.map((entry, index) => (
            <Bar
              key={index}
              dataKey={entry.name}
              stackId="a"
              fill={entry.color}
              isAnimationActive={false}
              barSize={56}
            >
              <LabelList
                dataKey={entry.name}
                content={({ value, x, y, width }) => {
                  if (Number(value) < 7) {
                    return null
                  }

                  const calculateXPosition = Number(x) + Number(width) / 2
                  const calculateYPosition = Number(y) + 23
                  return (
                    <text
                      x={calculateXPosition}
                      y={calculateYPosition}
                      fill={theme.palette.common.white}
                      textAnchor="middle"
                      dominantBaseline="middle"
                      fontWeight="bold"
                    >
                      {value}%
                    </text>
                  )
                }}
              />
            </Bar>
          ))}
        </BarChart>
      </ResponsiveContainer>
      <Stack sx={legendContainer}>
        {data.map((item, index) => (
          <Stack key={index} sx={legendItem}>
            <Box sx={() => legendDot(item.color)}></Box>
            <Typography sx={legendLabel}>{item.name}</Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  )
}
